var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.327 5.4088C13.9331 4.61057 13.3066 4 12.4975 4C11.6892 4 11.0607 4.60955 10.6631 5.40721L10.6626 5.40835L9.36321 8.02874L9.361 8.03325C9.32693 8.10339 9.2408 8.21087 9.10584 8.31177C8.9712 8.41244 8.84462 8.46421 8.77044 8.47712L6.41676 8.87143C5.55461 9.01633 4.81536 9.44261 4.57528 10.2007C4.33594 10.9565 4.69091 11.7328 5.30637 12.3534L7.13728 14.1995C7.20062 14.2634 7.27755 14.391 7.32646 14.5633C7.37498 14.7343 7.37794 14.8859 7.35775 14.9786L6.83417 17.2614C6.61515 18.2158 6.68394 19.1907 7.38486 19.7064C8.0889 20.2245 9.0377 19.992 9.87601 19.4904L12.0788 18.1755L12.0804 18.1745C12.1677 18.1239 12.3187 18.0814 12.5012 18.0814C12.6852 18.0814 12.8328 18.1246 12.9137 18.1729L15.1213 19.4907C15.9603 19.9904 16.9104 20.227 17.6145 19.7094C18.316 19.1937 18.381 18.2168 18.1627 17.2619L17.639 14.9786C17.6188 14.8859 17.6218 14.7342 17.6703 14.5633C17.7192 14.391 17.7961 14.2634 17.8595 14.1995L19.6889 12.3548L19.6898 12.3539C20.3091 11.7333 20.6652 10.9565 20.4239 10.1996C20.1824 9.44199 19.4418 9.01627 18.5803 8.87149L16.2252 8.47694"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.50b64f7d.svg";
export { ForwardRef as ReactComponent };